import { useContext } from 'react';
import PortfolioItemContext from '../../../../../PortfolioItemContext';
import sortByName from '@/lib/utils/sorting/sortByName';
import RemoveTag from './RemoveTag';
import AttachedTag from './AttachedTag';
import TagInfo from './TagInfo';
import { Tooltip } from '@mui/material';
import useIsPortfolioReadOnly from '@/components/ChallengePortfolio/NormalView/useIsPortfolioReadonly';

const AttachedTags = () => {
  const { portfolioItem } = useContext(PortfolioItemContext);
  const portfolioIsReadonly = useIsPortfolioReadOnly();

  if (portfolioItem.tags.length === 0) {
    return null;
  }

  return (
    <>
      {[...portfolioItem.tags].sort(sortByName).map(tag => (
        <AttachedTag tagColor={tag.color} key={tag.id}>
          {tag.name.length > 45 ? (
            <Tooltip title={tag.name}>
              <span>{tag.name}</span>
            </Tooltip>
          ) : (
            <span>{tag.name}</span>
          )}
          {tag.info !== null && <TagInfo tag={tag} />}
          {!portfolioIsReadonly && <RemoveTag tag={tag} />}
        </AttachedTag>
      ))}
    </>
  );
};

export default AttachedTags;
